import React from 'react'
import styled from 'styled-components'
import { Form, Field } from 'react-final-form'
import { flexBoxStyles } from '../../components/Flexbox'
import Button from '../../components/Button'
import { disabilityOptions } from '../Patient/constants'
import Select from '../../components/Select/index'
import CloseIcon from '../../images/closeIcon.svg'
import { kinds, speSubgroups, areas } from './utils'
import TextInput from '../../components/TextInput'

const fieldWidth = 310
const smallFieldWidth = 150
const numberRegex = /[^0-9]/g

const FilterForm = ({ onSubmit, onClose, initialValues }) => {
  const formatNumbers = (value) =>
    value === undefined ? '' : value.toString().replace(numberRegex, '')

  return (
    <Form
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values) => onSubmit(values)}
    >
      {({ handleSubmit, invalid, form }) => (
        <FormWrapper>
          <Header justify="space-between" align="flex-start">
            Filtruj
            <CloseButton
              onClick={onClose}
              icon={CloseIcon}
              altTag=""
              color="plain"
              ariaLabel="Zamknij"
            />
          </Header>
          <Field
            component={TextInput}
            width={smallFieldWidth}
            label="Wiek od"
            type="text"
            name="minAge"
            format={formatNumbers}
            formatOnBlur
            initialValue=""
          />
          <Field
            component={TextInput}
            width={smallFieldWidth}
            label="Wiek do"
            type="text"
            name="maxAge"
            format={formatNumbers}
            formatOnBlur
            initialValue=""
          />
          <Field
            isMulti
            isClearable
            name="areas"
            component={Select}
            width={fieldWidth}
            label="Obszar"
            aria-label={"Obszar"}
            options={areas}
          />
          <Field
            isMulti
            isClearable
            name="kinds"
            component={Select}
            width={fieldWidth}
            label="Rodzaj"
            aria-label={"Rodzaj"}
            options={kinds}
          />

          <Field
            isClearable
            isMulti
            name="speGroups"
            component={Select}
            width={fieldWidth}
            label="Grupa SPE"
            aria-label={"Grupa SPE"}
            options={disabilityOptions}
          />

          <Field
            isClearable
            isMulti
            name="speSubgroups"
            component={Select}
            width={fieldWidth}
            label="Podgrupa SPE"
            aria-label={"Podgrupa SPE"}
            options={speSubgroups}
          />

          <StyledButton
            width={`${fieldWidth}px`}
            label="Filtruj"
            onClick={handleSubmit}
            disabled={invalid}
          />
          <StyledButton
            color="white"
            width={`${fieldWidth}px`}
            label="Reset"
            onClick={() => {
              form.reset()
              onSubmit({ search: initialValues.search })
            }}
          />
        </FormWrapper>
      )}
    </Form>
  )
}
const Header = styled.header`
  height: 100%;
  width: 100%;
  padding: 5px 0 0 0;
  ${flexBoxStyles}
`
const FormWrapper = styled.div`
  padding: 0 10px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 85px;
  align-items: center;
  justify-items: center;
  height: 100vh;
  > header {
    grid-column: 1 / 3;
  }
  > button {
    grid-column: 1 / 3;
  }
  > div {
    &:nth-child(2) {
      grid-column: 1 / 2;
    }
    &:nth-child(3) {
      grid-column: 2 / 3;
    }
    &:nth-child(4) {
      grid-column: 1 / 3;
    }
    &:nth-child(5) {
      grid-column: 1 / 3;
    }
    &:nth-child(6) {
      grid-column: 1 / 3;
    }
    &:nth-child(7) {
      grid-column: 1 / 3;
    }
  }
`
const StyledButton = styled(Button)`
  opacity: ${(props) => (props.disabled ? '0.5' : '1')};
`

const CloseButton = styled(Button)`
  padding: 0;
  margin: 0;
  width: 32px;
  height: 32px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    position: static;
    margin-left: auto;
  }
`;

export default FilterForm
